import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import bannerReducer from "./bannerSlice";
import teamsAccessReducer from "./teamsAccessSlice";

export const store = configureStore({
  reducer: {
    banner: bannerReducer,
    teamsAccess: teamsAccessReducer,
  },
  // TODO: Concat the baseApi slice middleware when made
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: true,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
